module.exports = __webpack_public_path__ + "img/petdiary.64ec66c2.png";